var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.1665 4.16667C2.70627 4.16667 2.33317 4.53976 2.33317 5V16.6667C2.33317 17.1269 2.70627 17.5 3.1665 17.5H14.8332C15.2934 17.5 15.6665 17.1269 15.6665 16.6667V5C15.6665 4.53976 15.2934 4.16667 14.8332 4.16667H3.1665ZM0.666504 5C0.666504 3.61929 1.78579 2.5 3.1665 2.5H14.8332C16.2139 2.5 17.3332 3.61929 17.3332 5V16.6667C17.3332 18.0474 16.2139 19.1667 14.8332 19.1667H3.1665C1.78579 19.1667 0.666504 18.0474 0.666504 16.6667V5Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3333 0.833008C12.7936 0.833008 13.1667 1.2061 13.1667 1.66634V4.99967C13.1667 5.45991 12.7936 5.83301 12.3333 5.83301C11.8731 5.83301 11.5 5.45991 11.5 4.99967V1.66634C11.5 1.2061 11.8731 0.833008 12.3333 0.833008Z",
    fill: "#888888"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66683 0.833008C6.12707 0.833008 6.50016 1.2061 6.50016 1.66634V4.99967C6.50016 5.45991 6.12707 5.83301 5.66683 5.83301C5.20659 5.83301 4.8335 5.45991 4.8335 4.99967V1.66634C4.8335 1.2061 5.20659 0.833008 5.66683 0.833008Z",
    fill: "#888888"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666504 8.33333C0.666504 7.8731 1.0396 7.5 1.49984 7.5H16.4998C16.9601 7.5 17.3332 7.8731 17.3332 8.33333C17.3332 8.79357 16.9601 9.16667 16.4998 9.16667H1.49984C1.0396 9.16667 0.666504 8.79357 0.666504 8.33333Z",
    fill: "#888888"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.878e7af7.svg";
export { ForwardRef as ReactComponent };